import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'

import { projectContext, loadingContext, unfolder, useTranslate, openAlert } from '../lib'
import { urlValue } from '../lib'
import '../styles/styles.css'
import '../styles/newProjectModal.scss'
import { customModal } from '../styles/customModal'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { Alerts } from './common/Alerts'

export default function EditSubCampaingModal({ isModalOpen, closeModal, campaign_id, editTexts }) {
  const [loading, setLoading] = useContext(loadingContext)
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [error, setError] = useState({ name: "" })
  const { t } = useTranslate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (isModalOpen?.subcampaing) {
      setValue('name', isModalOpen.subcampaing.name || isModalOpen.subcampaing.sub_campaing_name);
    }
  }, [isModalOpen]);

  const onSubmit = async data => {
    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g;
    if (!exp.test(data.name)) {
      ok = false;
      setError({ ...error, name: t('errors.nameInvalid') })
    }
    if (ok) {
      const subId = isModalOpen?.subcampaing?.id || isModalOpen?.subcampaing?.sub_campaing_id || 0;
      const dataSend = {
        name: data.name,
        campaign_id: campaign_id,
        id: subId
      }
      axios({
        method: 'post',
        url: `${urlValue}/studio/campaign/subcampign/edit/${subId}`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          closeModal()
          setLoading(false)
          window.location.href = "/campaigns";
        })
        .catch(function (error) {
          if (error.response?.status === 409) {
            openAlert('#alert-ac', () => { setAlert({ title: error?.response?.data?.message, visible: true, error: true }) }, 5000,
              () => { setAlert({ ...alert, visible: false }) });
          }
          else {
            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.subcampaignNotSaved'), visible: true, error: true }) }, 4000,
              () => { setAlert({ ...alert, visible: false }) });
          }
          setLoading(false)
        })
    }
  }

  return (
    <div className="newProject-modal newCampaing-modal">
      <h1>{editTexts?.title || t('menu.editSubCampaign')}</h1>
      <form onSubmit={handleSubmit(onSubmit)} style={{width: '100%'}}>
        <div className="inputs" id="name">
          <div className="input tooltip">
            <span>{t('common.name')}:</span>
            <input placeholder={t('menu.newSubcampaignName')} className='input-data' id='namescp-tp' {...register('name', { required: true })} type="text" />
            <Tooltip anchorId="namescp-tp" content={t('alerts.charactersNameTooltip')} place="top" />
          </div>
        </div>
        <div className="footer">
          <div className='cont-buttons'>
            {errors.name?.type === 'required'
              ? (
                <span style={{ color: "red" }}>{t('menu.fieldsRequired')}</span>
              ) : (
                <span> </span>
              )}
            <span className='errors-msg'>{error.name}</span>
          </div>
          <div className='cont-buttons' style={{marginTop: 25}}>
            <div className="buttons">
              <button className="cancel btn-bottom btn-bottom-cancel" type="button" onClick={() => closeModal()}>
                {t('common.cancel')}
              </button>
              <button className="create btn-bottom btn-bottom-create" type="submit">
                {editTexts?.button || t('common.edit')}
              </button>
            </div>
          </div>
        </div>
      </form>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error}/>} 
    </div>
  )
}
